export const sharedOfferedModelsDe = {
  "OfferedModels.ExecutionRegion.EuropeGuaranteed": "Europa (EU/EWR, Großbritannien, Schweiz)",
  "OfferedModels.ExecutionRegion.UsGuaranteed": "Verarbeitung ausschließlich in den USA",
  "OpenRouterProfile.Authentication": "Der OpenRouter-Zugangsschlüssel fehlt oder wurde abgelehnt.",
  "OpenRouterProfile.Credits": "Das OpenRouter-Guthaben reicht für den Test nicht aus.",
  "OpenRouterProfile.ProviderRegionRequired": "Die Regionsvorgabe ist mit dem gewählten Anbieterzugang nicht vereinbar.",
  "OpenRouterProfile.Permission": "Die Kontoberechtigung oder eine Kontorichtlinie verhindert diese Verarbeitung.",
  "OpenRouterProfile.NoRoute": "Für Modell, Region und Datenschutzvorgaben ist keine passende OpenRouter-Route verfügbar.",
  "OpenRouterProfile.RateLimited": "OpenRouter begrenzt die Anfragen. Bitte später erneut prüfen.",
  "OpenRouterProfile.Timeout": "Die OpenRouter-Verfügbarkeitsprüfung hat das Zeitlimit überschritten.",
  "OpenRouterProfile.InvalidResponse": "Der OpenRouter-Test lieferte keine vollständige gültige Antwort.",
  "OpenRouterProfile.Unavailable": "OpenRouter konnte diese Konfiguration nicht erfolgreich ausführen.",
  "OfferedModels.OperationType": "Betriebsart",
  "OfferedModels.OperationType.chat": "Chat",
  "OfferedModels.OperationType.embedding": "Embedding",
  "OfferedModels.OperationType.classification": "Klassifikation",
  "OfferedModels.OperationType.decisions": "Entscheidungen",
  "OfferedModels.OperationType.image": "Bild",
  "OfferedModels.OperationType.video": "Video",
  "OfferedModels.OperationType.speech": "Sprachausgabe",
  "OfferedModels.OperationType.transcription": "Transkription",
  "OfferedModels.OperationType.music": "Musik",
  "OfferedModels.OperationType.sound_effect": "Soundeffekt",
  "Models": "Modelle",
  "Add Offered Model": "Modell hinzufügen",
  "Edit Offered Model": "Modell bearbeiten",
  "Profile Name": "Profilname",
  "Strengths and weaknesses": "Stärken und Schwächen",
  "Provider": "Anbieter",
  "Model": "Modell",
  "OfferedModels.Provider": "Anbieter",
  "OfferedModels.Model": "Modell",
  "OfferedModels.ModelLocation": "Ausführung",
  "OfferedModels.ProcessingLocations": "Verarbeitungsstandorte",
  "OfferedModels.ProcessingLocation": "Modellstandort",
  "OfferedModels.SelectOneProcessingLocation": "Bitte genau einen Modellstandort auswählen.",
  "OfferedModels.LocationAndPrivacy": "Standort und Datenschutz",
  "OfferedModels.OnlyEurope": "nur in Europa verarbeiten (EU/EWR, Großbritannien, Schweiz)",
  "OfferedModels.OnlyUs": "nur in den USA verarbeiten",
  "OfferedModels.ExecutionParameters": "Betriebsparameter",
  "OfferedModels.ModelLocation.MqorvaInfrastructure": "mQorva-Infrastruktur",
  "OfferedModels.ModelLocation.MqorvaInfrastructureDescription": "Modelle in der von mQorva betriebenen Infrastruktur dürfen genutzt werden.",
  "OfferedModels.ModelLocation.EuProviders": "EU-gehostete Modelle",
  "OfferedModels.ModelLocation.EuProvidersDescription": "Modelle, die in der EU gehostet werden, dürfen genutzt werden.",
  "OfferedModels.ModelLocation.WorldProviders": "weltweit gehostete Modelle",
  "OfferedModels.ModelLocation.WorldProvidersDescription": "Modelle, die außerhalb der EU gehostet werden, dürfen genutzt werden — darunter auch Anbieter ohne zugesicherte Region.",
  "OfferedModels.ExecutionRegion.EuGuaranteed": "Verarbeitung ausschließlich in der EU",
  "OfferedModels.ExecutionRegion.NoRegionalGuarantee": "keine zugesicherte Verarbeitungsregion",
  "OfferedModels.InfrastructureOperator.Mqorva": "von mQorva betriebene Infrastruktur",
  "OfferedModels.InfrastructureOperator.External": "externe Infrastruktur",
  "OfferedModels.ExecutionPlacementUnavailable": "Ausführungsort nicht ermittelbar",
  "OfferedModels.InputCapabilities": "Fähigkeiten",
  "OfferedModels.InputCapabilitiesUnknown": "nicht ermittelt",
  "OfferedModels.InputCapability.text": "Text",
  "OfferedModels.InputCapability.image": "Bild",
  "OfferedModels.InputCapability.document": "Dokument",
  "OfferedModels.InputCapability.audio": "Audio",
  "OfferedModels.InputCapability.video": "Video",
  "OfferedModels.ExecutionRegion.EuGuaranteedShort": "EU-Verarbeitung",
  "OfferedModels.ExecutionRegion.NoRegionalGuaranteeShort": "keine EU-Garantie",
  "OfferedModels.InfrastructureOperator.MqorvaShort": "mQorva",
  "OfferedModels.InfrastructureOperator.ExternalShort": "extern",
  "Enabled": "aktiviert",
  "Pricing": "Preise",
  "Input price per million": "Eingabepreis pro Million",
  "Output price per million": "Ausgabepreis pro Million",
  "Unit price": "Einheitspreis",
  "Price per image": "Preis pro Bild",
  "Image unit": "Bild",
  "Input": "Input",
  "Output": "Output",
  "Cached input": "gecachter Input",
  "Cache write": "Cache-Schreibvorgang",
  "Official provider price": "offizieller Anbieterpreis",
  "Internal cost basis": "interne Kostenbasis",
  "Price current": "aktuell",
  "Price stale": "veraltet",
  "Price update required": "Preis für dieses Modell fehlt",
  "Internal cost basis required": "interne Kostenbasis für dieses Modell fehlt",
  "Price billing model unsupported": "Kosten nicht berechenbar",
  "Price billing model unsupported hint":
    "Der Anbieterpreis dieses Modells passt nicht zu den Verbrauchsdaten, die für seine Betriebsart erfasst werden. Die Nutzung wird deshalb ohne Kosten erfasst, bis die Berechnung ergänzt ist.",
  "Pricing managed automatically": "Anbieterpreise werden automatisch ermittelt und können hier nicht bearbeitet werden.",
  "Price source": "Preisquelle",
  "Fetched at": "abgerufen am",
  "Long context pricing": "Langkontextpreis ab",
  "Processing": "Verarbeitung",
  "Max parallel": "maximale Parallelität",
  "Request delay": "Anfrageabstand",
  "Request timeout": "Anfrage-Timeout",
  "Max retry attempts": "maximale Wiederholungen",
  "Max output tokens": "maximale Ausgabe-Tokens",
  "Reasoning": "Reasoning",
  "Reasoning off": "aus",
  "Reasoning minimal": "minimal",
  "Reasoning low": "niedrig",
  "Reasoning medium": "mittel",
  "Reasoning high": "hoch",
  "Reasoning extra high": "sehr hoch",
  "Reasoning maximum": "maximal",
  "Value must not be negative": "Der Wert darf nicht negativ sein.",
  "Max parallel range error": "Die Parallelität muss zwischen 1 und 64 liegen.",
  "Request delay range error": "Der Anfrageabstand muss zwischen 0 und 60000 ms liegen.",
  "Request timeout range error": "Der Anfrage-Timeout muss zwischen 5 und 43200 Sekunden liegen.",
  "Max retry attempts range error": "Die Wiederholungen müssen zwischen 0 und 10 liegen.",
  "Max output tokens range error": "Die Ausgabe-Tokens müssen zwischen 1 und 200000 liegen.",
  "Save": "speichern",
  "Cancel": "abbrechen",
  "Required": "wird benötigt.",
  "No models configured": "Keine Modelle konfiguriert",
  "Actions": "Aktionen",
  "OfferedModels.Saved": "Modelle gespeichert",
  "OfferedModels.DeleteTitle": "Modell löschen?",
  "OfferedModels.Delete": "löschen",
  "OfferedModelInUse": "Das Modell wird noch von mindestens einem Agenten verwendet und kann nicht deaktiviert oder gelöscht werden.",
  "Current": "aktuell",
  "Use custom model": "\"{model}\" als eigenes Modell verwenden",
  "OpenRouter data collection": "Datenverwendung durch Lieferanten verbieten",
  "OpenRouter data collection help": "Berücksichtigt nur Lieferanten, die Eingaben und Ausgaben nicht für Analyse, Training oder eine andere nichtflüchtige Datenverwendung nutzen.",
  "OpenRouter zero data retention": "Datenaufbewahrung beim Lieferanten verbieten (ZDR)",
  "OpenRouter zero data retention help": "Berücksichtigt nur Lieferanten mit Zero Data Retention. Eingaben und Ausgaben werden nach der Anfrage nicht beim Lieferanten aufbewahrt.",
  "OpenRouter processing region": "Verarbeitungsregion",
  "OpenRouter region global": "weltweit",
  "OpenRouter region europe": "Europa (EU/EWR, Großbritannien, Schweiz)",
  "OpenRouter region us": "USA",
  "OpenRouter check and save": "prüfen und speichern",
  "OpenRouter profile price unavailable": "Preis für diese Konfiguration nicht ermittelt",
  "OpenRouter profile price help": "Katalogspanne der regionalen Routen mit diesen Datenschutzvorgaben. Kontorichtlinien können die Auswahl weiter einschränken. Abgerechnet wird die tatsächlich genutzte Route.",
  "OpenRouter save test help": "Text- und Decision-Profile werden mit einer kleinen kostenpflichtigen Anfrage geprüft. Bei Medien werden Modell und Route ohne Generierung geprüft. Die Europa-Region genügt keiner Vorgabe, die ausschließlich EU-Verarbeitung erlaubt.",
  "OpenRouter privacy heading": "Zulässige Datenverarbeitung bei OpenRouter",
  "OpenRouter data use denied": "Datenverwendung gesperrt",
  "OpenRouter EU processing only": "Nur Verarbeitung in der EU zulassen",
  "OpenRouter EU processing only help": "OpenRouter verwendet ausschließlich den EU-Endpunkt. Das Modell muss dort verfügbar sein; ein Rückfall auf die globale Route findet nicht statt.",
} as const;

export const sharedOfferedModelsEn = {
  "OfferedModels.ExecutionRegion.EuropeGuaranteed": "Europe (EU/EEA, UK, Switzerland)",
  "OfferedModels.ExecutionRegion.UsGuaranteed": "Processing exclusively in the USA",
  "OpenRouterProfile.Authentication": "The OpenRouter API key is missing or was rejected.",
  "OpenRouterProfile.Credits": "The OpenRouter balance is insufficient for this test.",
  "OpenRouterProfile.ProviderRegionRequired": "The region restriction is incompatible with the selected provider access.",
  "OpenRouterProfile.Permission": "Account permissions or a policy prevent this processing configuration.",
  "OpenRouterProfile.NoRoute": "No OpenRouter route matches this model, region and privacy configuration.",
  "OpenRouterProfile.RateLimited": "OpenRouter is rate limiting requests. Please try again later.",
  "OpenRouterProfile.Timeout": "The OpenRouter availability test timed out.",
  "OpenRouterProfile.InvalidResponse": "The OpenRouter test did not return a complete valid response.",
  "OpenRouterProfile.Unavailable": "OpenRouter could not execute this configuration successfully.",
  "OfferedModels.OperationType": "Operation type",
  "OfferedModels.OperationType.chat": "Chat",
  "OfferedModels.OperationType.embedding": "Embedding",
  "OfferedModels.OperationType.classification": "Classification",
  "OfferedModels.OperationType.decisions": "Decisions",
  "OfferedModels.OperationType.image": "Image",
  "OfferedModels.OperationType.video": "Video",
  "OfferedModels.OperationType.speech": "Speech",
  "OfferedModels.OperationType.transcription": "Transcription",
  "OfferedModels.OperationType.music": "Music",
  "OfferedModels.OperationType.sound_effect": "Sound effect",
  "Models": "Models",
  "Add Offered Model": "Add model",
  "Edit Offered Model": "Edit model",
  "Profile Name": "Profile name",
  "Strengths and weaknesses": "Strengths and weaknesses",
  "Provider": "Provider",
  "Model": "Model",
  "OfferedModels.Provider": "Provider",
  "OfferedModels.Model": "Model",
  "OfferedModels.ModelLocation": "Execution",
  "OfferedModels.ProcessingLocations": "Processing locations",
  "OfferedModels.ProcessingLocation": "Model location",
  "OfferedModels.SelectOneProcessingLocation": "Please select exactly one model location.",
  "OfferedModels.LocationAndPrivacy": "Location and privacy",
  "OfferedModels.OnlyEurope": "process only in Europe (EU/EEA, UK, Switzerland)",
  "OfferedModels.OnlyUs": "process only in the USA",
  "OfferedModels.ExecutionParameters": "Execution parameters",
  "OfferedModels.ModelLocation.MqorvaInfrastructure": "mQorva infrastructure",
  "OfferedModels.ModelLocation.MqorvaInfrastructureDescription": "Models hosted in infrastructure operated by mQorva may be used.",
  "OfferedModels.ModelLocation.EuProviders": "EU-hosted models",
  "OfferedModels.ModelLocation.EuProvidersDescription": "Models hosted in the EU may be used.",
  "OfferedModels.ModelLocation.WorldProviders": "Globally hosted models",
  "OfferedModels.ModelLocation.WorldProvidersDescription": "Models hosted outside the EU may be used, including providers without a guaranteed region.",
  "OfferedModels.ExecutionRegion.EuGuaranteed": "Processing exclusively in the EU",
  "OfferedModels.ExecutionRegion.NoRegionalGuarantee": "No guaranteed processing region",
  "OfferedModels.InfrastructureOperator.Mqorva": "Infrastructure operated by mQorva",
  "OfferedModels.InfrastructureOperator.External": "External infrastructure",
  "OfferedModels.ExecutionPlacementUnavailable": "Execution placement unavailable",
  "OfferedModels.InputCapabilities": "Capabilities",
  "OfferedModels.InputCapabilitiesUnknown": "Not determined",
  "OfferedModels.InputCapability.text": "Text",
  "OfferedModels.InputCapability.image": "Image",
  "OfferedModels.InputCapability.document": "Document",
  "OfferedModels.InputCapability.audio": "Audio",
  "OfferedModels.InputCapability.video": "Video",
  "OfferedModels.ExecutionRegion.EuGuaranteedShort": "EU processing",
  "OfferedModels.ExecutionRegion.NoRegionalGuaranteeShort": "No EU guarantee",
  "OfferedModels.InfrastructureOperator.MqorvaShort": "mQorva",
  "OfferedModels.InfrastructureOperator.ExternalShort": "External",
  "Enabled": "enabled",
  "Pricing": "Pricing",
  "Input price per million": "Input price per million",
  "Output price per million": "Output price per million",
  "Unit price": "Unit price",
  "Price per image": "Price per image",
  "Image unit": "image",
  "Input": "Input",
  "Output": "Output",
  "Cached input": "Cached input",
  "Cache write": "Cache write",
  "Official provider price": "Official provider price",
  "Internal cost basis": "Internal cost basis",
  "Price current": "current",
  "Price stale": "stale",
  "Price update required": "Price for this model is missing",
  "Internal cost basis required": "Internal cost basis required",
  "Price billing model unsupported": "Cost cannot be calculated",
  "Price billing model unsupported hint":
    "This model's provider price does not match the usage data recorded for its operation type. Usage is therefore recorded without cost until the calculation is added.",
  "Pricing managed automatically": "Provider prices are determined automatically and cannot be edited here.",
  "Price source": "Price source",
  "Fetched at": "fetched at",
  "Long context pricing": "Long-context price from",
  "Processing": "Processing",
  "Max parallel": "Max. parallel",
  "Request delay": "request delay",
  "Request timeout": "request timeout",
  "Max retry attempts": "max retry attempts",
  "Max output tokens": "max output tokens",
  "Reasoning": "Reasoning",
  "Reasoning off": "off",
  "Reasoning minimal": "minimal",
  "Reasoning low": "low",
  "Reasoning medium": "medium",
  "Reasoning high": "high",
  "Reasoning extra high": "extra high",
  "Reasoning maximum": "maximum",
  "Value must not be negative": "The value must not be negative.",
  "Max parallel range error": "Parallelism must be between 1 and 64.",
  "Request delay range error": "Request delay must be between 0 and 60000 ms.",
  "Request timeout range error": "Request timeout must be between 5 and 43200 seconds.",
  "Max retry attempts range error": "Retry attempts must be between 0 and 10.",
  "Max output tokens range error": "Output tokens must be between 1 and 200000.",
  "Save": "Save",
  "Cancel": "Cancel",
  "Required": "required.",
  "No models configured": "No models configured",
  "Actions": "Actions",
  "OfferedModels.Saved": "Models saved",
  "OfferedModels.DeleteTitle": "Delete model?",
  "OfferedModels.Delete": "Delete",
  "OfferedModelInUse": "The model is still used by at least one agent and cannot be disabled or deleted.",
  "Current": "current",
  "Use custom model": "Use \"{model}\" as custom model",
  "OpenRouter data collection": "Prohibit supplier data use",
  "OpenRouter data collection help": "Only suppliers that do not use inputs and outputs for analysis, training, or other non-transient data use are eligible.",
  "OpenRouter zero data retention": "Prohibit supplier data retention (ZDR)",
  "OpenRouter processing region": "Processing region",
  "OpenRouter region global": "Worldwide",
  "OpenRouter region europe": "Europe (EU/EEA, UK, Switzerland)",
  "OpenRouter region us": "USA",
  "OpenRouter check and save": "Check and save",
  "OpenRouter profile price unavailable": "Price for this configuration not determined",
  "OpenRouter profile price help": "Catalog range for regional routes matching these privacy requirements. Account policies may narrow the selection further. Actual charges depend on the route used.",
  "OpenRouter save test help": "Text and decision profiles are tested with a small billable request. Media profiles are checked against model and route metadata without generating media. The Europe region does not satisfy a strictly EU-only requirement.",
  "OpenRouter zero data retention help": "Only suppliers with Zero Data Retention are eligible. Inputs and outputs are not retained after the request.",
  "OpenRouter privacy heading": "Permitted data processing at OpenRouter",
  "OpenRouter data use denied": "Data use denied",
  "OpenRouter EU processing only": "Allow processing in the EU only",
  "OpenRouter EU processing only help": "OpenRouter uses the EU endpoint exclusively. The model must be available there; there is no fallback to the global route.",
} as const;

export const sharedOfferedModelsRu = {
  "OfferedModels.ExecutionRegion.EuropeGuaranteed": "Европа (ЕС/ЕЭЗ, Великобритания, Швейцария)",
  "OfferedModels.ExecutionRegion.UsGuaranteed": "Обработка только в США",
  "OpenRouterProfile.Authentication": "Ключ OpenRouter отсутствует или отклонён.",
  "OpenRouterProfile.Credits": "Недостаточно средств OpenRouter для проверки.",
  "OpenRouterProfile.ProviderRegionRequired": "Ограничение региона несовместимо с выбранным подключением провайдера.",
  "OpenRouterProfile.Permission": "Права или политика аккаунта не допускают эту обработку.",
  "OpenRouterProfile.NoRoute": "Нет маршрута OpenRouter для этой модели, региона и требований конфиденциальности.",
  "OpenRouterProfile.RateLimited": "OpenRouter ограничивает запросы. Повторите проверку позже.",
  "OpenRouterProfile.Timeout": "Время проверки доступности OpenRouter истекло.",
  "OpenRouterProfile.InvalidResponse": "Проверка OpenRouter не вернула полный корректный ответ.",
  "OpenRouterProfile.Unavailable": "OpenRouter не смог выполнить запрос с этой конфигурацией.",
  "OfferedModels.OperationType": "Тип операции",
  "OfferedModels.OperationType.chat": "Чат",
  "OfferedModels.OperationType.embedding": "Эмбеддинги",
  "OfferedModels.OperationType.classification": "Классификация",
  "OfferedModels.OperationType.decisions": "Решения",
  "OfferedModels.OperationType.image": "Изображение",
  "OfferedModels.OperationType.video": "Видео",
  "OfferedModels.OperationType.speech": "Синтез речи",
  "OfferedModels.OperationType.transcription": "Транскрипция",
  "OfferedModels.OperationType.music": "Музыка",
  "OfferedModels.OperationType.sound_effect": "Звуковой эффект",
  "Models": "Модели",
  "Add Offered Model": "добавить модель",
  "Edit Offered Model": "редактировать модель",
  "Profile Name": "название профиля",
  "Strengths and weaknesses": "сильные и слабые стороны",
  "Provider": "провайдер",
  "Model": "модель",
  "OfferedModels.Provider": "провайдер",
  "OfferedModels.Model": "модель",
  "OfferedModels.ModelLocation": "Выполнение",
  "OfferedModels.ProcessingLocations": "Места обработки",
  "OfferedModels.ProcessingLocation": "Место размещения модели",
  "OfferedModels.SelectOneProcessingLocation": "Выберите ровно одно место размещения модели.",
  "OfferedModels.LocationAndPrivacy": "Размещение и конфиденциальность",
  "OfferedModels.OnlyEurope": "обрабатывать только в Европе (ЕС/ЕЭЗ, Великобритания, Швейцария)",
  "OfferedModels.OnlyUs": "обрабатывать только в США",
  "OfferedModels.ExecutionParameters": "Параметры выполнения",
  "OfferedModels.ModelLocation.MqorvaInfrastructure": "инфраструктура mQorva",
  "OfferedModels.ModelLocation.MqorvaInfrastructureDescription": "Модели, размещённые в инфраструктуре mQorva, разрешено использовать.",
  "OfferedModels.ModelLocation.EuProviders": "ЕС",
  "OfferedModels.ModelLocation.EuProvidersDescription": "Модели, размещённые в ЕС, разрешено использовать.",
  "OfferedModels.ModelLocation.WorldProviders": "весь мир",
  "OfferedModels.ModelLocation.WorldProvidersDescription": "Модели, размещённые за пределами ЕС, разрешено использовать — включая поставщиков без гарантированного региона.",
  "OfferedModels.ExecutionRegion.EuGuaranteed": "обработка только в ЕС",
  "OfferedModels.ExecutionRegion.NoRegionalGuarantee": "регион обработки не гарантирован",
  "OfferedModels.InfrastructureOperator.Mqorva": "инфраструктура под управлением mQorva",
  "OfferedModels.InfrastructureOperator.External": "внешняя инфраструктура",
  "OfferedModels.ExecutionPlacementUnavailable": "место выполнения не определено",
  "OfferedModels.InputCapabilities": "возможности",
  "OfferedModels.InputCapabilitiesUnknown": "не определено",
  "OfferedModels.InputCapability.text": "текст",
  "OfferedModels.InputCapability.image": "изображение",
  "OfferedModels.InputCapability.document": "документ",
  "OfferedModels.InputCapability.audio": "аудио",
  "OfferedModels.InputCapability.video": "видео",
  "OfferedModels.ExecutionRegion.EuGuaranteedShort": "обработка в ЕС",
  "OfferedModels.ExecutionRegion.NoRegionalGuaranteeShort": "без гарантии ЕС",
  "OfferedModels.InfrastructureOperator.MqorvaShort": "mQorva",
  "OfferedModels.InfrastructureOperator.ExternalShort": "внешняя",
  "Enabled": "включено",
  "Pricing": "цены",
  "Input price per million": "цена ввода за миллион",
  "Output price per million": "цена вывода за миллион",
  "Unit price": "цена за единицу",
  "Price per image": "цена за изображение",
  "Image unit": "изображение",
  "Input": "ввод",
  "Output": "вывод",
  "Cached input": "кешированный ввод",
  "Cache write": "запись в кеш",
  "Official provider price": "официальная цена провайдера",
  "Internal cost basis": "внутренняя база затрат",
  "Price current": "актуально",
  "Price stale": "устарело",
  "Price update required": "Цена для этой модели отсутствует",
  "Internal cost basis required": "требуется внутренняя база затрат",
  "Price billing model unsupported": "стоимость не рассчитывается",
  "Price billing model unsupported hint":
    "Цена провайдера для этой модели не соответствует данным о потреблении, которые фиксируются для её типа операции. Поэтому использование учитывается без стоимости, пока не будет добавлен расчёт.",
  "Pricing managed automatically": "Цены провайдера определяются автоматически и не редактируются здесь.",
  "Price source": "источник цены",
  "Fetched at": "получено",
  "Long context pricing": "цена длинного контекста от",
  "Processing": "обработка",
  "Max parallel": "максимальная параллельность",
  "Request delay": "задержка запроса",
  "Request timeout": "тайм-аут запроса",
  "Max retry attempts": "максимум повторов",
  "Max output tokens": "максимум токенов вывода",
  "Reasoning": "глубина рассуждений",
  "Reasoning off": "выключено",
  "Reasoning minimal": "минимально",
  "Reasoning low": "низко",
  "Reasoning medium": "средне",
  "Reasoning high": "высоко",
  "Reasoning extra high": "очень высоко",
  "Reasoning maximum": "максимально",
  "Value must not be negative": "Значение не должно быть отрицательным.",
  "Max parallel range error": "Параллельность должна быть от 1 до 64.",
  "Request delay range error": "Задержка запроса должна быть от 0 до 60000 мс.",
  "Request timeout range error": "Тайм-аут запроса должен быть от 5 до 43200 секунд.",
  "Max retry attempts range error": "Количество повторов должно быть от 0 до 10.",
  "Max output tokens range error": "Количество токенов вывода должно быть от 1 до 200000.",
  "Save": "сохранить",
  "Cancel": "отмена",
  "Required": "обязательное поле",
  "No models configured": "модели не настроены",
  "Actions": "действия",
  "OfferedModels.Saved": "модели сохранены",
  "OfferedModels.DeleteTitle": "Удалить модель?",
  "OfferedModels.Delete": "удалить",
  "OfferedModelInUse": "Модель всё ещё используется как минимум одним агентом, поэтому её нельзя отключить или удалить.",
  "Current": "текущая",
  "Use custom model": "Использовать \"{model}\" как собственную модель",
  "OpenRouter data collection": "Запретить поставщикам использовать данные",
  "OpenRouter data collection help": "Допускаются только поставщики, не использующие входные и выходные данные для анализа, обучения или другого постоянного использования.",
  "OpenRouter zero data retention": "Запретить хранение данных у поставщика (ZDR)",
  "OpenRouter processing region": "Регион обработки",
  "OpenRouter region global": "Весь мир",
  "OpenRouter region europe": "Европа (ЕС/ЕЭЗ, Великобритания, Швейцария)",
  "OpenRouter region us": "США",
  "OpenRouter check and save": "Проверить и сохранить",
  "OpenRouter profile price unavailable": "Цена для этой конфигурации не определена",
  "OpenRouter profile price help": "Диапазон каталожных цен региональных маршрутов с этими требованиями. Политики аккаунта могут сузить выбор. Списывается стоимость фактического маршрута.",
  "OpenRouter save test help": "Текстовые профили и профили решений проверяются небольшим платным запросом. Для медиа проверяются модель и маршрут без генерации. Регион Европы не гарантирует обработку только в ЕС.",
  "OpenRouter zero data retention help": "Допускаются только поставщики с Zero Data Retention. Входные и выходные данные не сохраняются после запроса.",
  "OpenRouter privacy heading": "Допустимая обработка данных в OpenRouter",
  "OpenRouter EU processing only": "Разрешить обработку только в ЕС",
  "OpenRouter EU processing only help": "OpenRouter использует только конечную точку ЕС. Модель должна быть доступна там; перехода на глобальный маршрут нет.",
} as const;

export const sharedOfferedModelsUk = {
  "OfferedModels.ExecutionRegion.EuropeGuaranteed": "Європа (ЄС/ЄЕЗ, Велика Британія, Швейцарія)",
  "OfferedModels.ExecutionRegion.UsGuaranteed": "Обробка лише в США",
  "OpenRouterProfile.Authentication": "Ключ OpenRouter відсутній або відхилений.",
  "OpenRouterProfile.Credits": "Недостатньо коштів OpenRouter для перевірки.",
  "OpenRouterProfile.ProviderRegionRequired": "Обмеження регіону несумісне з вибраним підключенням провайдера.",
  "OpenRouterProfile.Permission": "Права або політика облікового запису не допускають цю обробку.",
  "OpenRouterProfile.NoRoute": "Немає маршруту OpenRouter для цієї моделі, регіону та вимог конфіденційності.",
  "OpenRouterProfile.RateLimited": "OpenRouter обмежує запити. Повторіть перевірку пізніше.",
  "OpenRouterProfile.Timeout": "Час перевірки доступності OpenRouter вичерпано.",
  "OpenRouterProfile.InvalidResponse": "Перевірка OpenRouter не повернула повної коректної відповіді.",
  "OpenRouterProfile.Unavailable": "OpenRouter не зміг виконати запит із цією конфігурацією.",
  "OfferedModels.OperationType": "Тип операції",
  "OfferedModels.OperationType.chat": "Чат",
  "OfferedModels.OperationType.embedding": "Ембединги",
  "OfferedModels.OperationType.classification": "Класифікація",
  "OfferedModels.OperationType.decisions": "Рішення",
  "OfferedModels.OperationType.image": "Зображення",
  "OfferedModels.OperationType.video": "Відео",
  "OfferedModels.OperationType.speech": "Синтез мовлення",
  "OfferedModels.OperationType.transcription": "Транскрипція",
  "OfferedModels.OperationType.music": "Музика",
  "OfferedModels.OperationType.sound_effect": "Звуковий ефект",
  "Models": "Моделі",
  "Add Offered Model": "Додати модель",
  "Edit Offered Model": "Редагувати модель",
  "Profile Name": "Ім'я профілю",
  "Strengths and weaknesses": "Сильні та слабкі сторони",
  "Provider": "Провайдер",
  "Model": "модель",
  "OfferedModels.Provider": "провайдер",
  "OfferedModels.Model": "модель",
  "OfferedModels.ModelLocation": "Виконання",
  "OfferedModels.ProcessingLocations": "Місця обробки",
  "OfferedModels.ProcessingLocation": "Місце розміщення моделі",
  "OfferedModels.SelectOneProcessingLocation": "Виберіть рівно одне місце розміщення моделі.",
  "OfferedModels.LocationAndPrivacy": "Розміщення та конфіденційність",
  "OfferedModels.OnlyEurope": "обробляти лише в Європі (ЄС/ЄЕЗ, Велика Британія, Швейцарія)",
  "OfferedModels.OnlyUs": "обробляти лише у США",
  "OfferedModels.ExecutionParameters": "Параметри виконання",
  "OfferedModels.ModelLocation.MqorvaInfrastructure": "інфраструктура mQorva",
  "OfferedModels.ModelLocation.MqorvaInfrastructureDescription": "Моделі, розміщені в інфраструктурі mQorva, дозволено використовувати.",
  "OfferedModels.ModelLocation.EuProviders": "ЄС",
  "OfferedModels.ModelLocation.EuProvidersDescription": "Моделі, розміщені в ЄС, дозволено використовувати.",
  "OfferedModels.ModelLocation.WorldProviders": "весь світ",
  "OfferedModels.ModelLocation.WorldProvidersDescription": "Моделі, розміщені поза межами ЄС, дозволено використовувати — включно з постачальниками без гарантованого регіону.",
  "OfferedModels.ExecutionRegion.EuGuaranteed": "обробка лише в ЄС",
  "OfferedModels.ExecutionRegion.NoRegionalGuarantee": "регіон обробки не гарантовано",
  "OfferedModels.InfrastructureOperator.Mqorva": "інфраструктура під керуванням mQorva",
  "OfferedModels.InfrastructureOperator.External": "зовнішня інфраструктура",
  "OfferedModels.ExecutionPlacementUnavailable": "місце виконання не визначено",
  "OfferedModels.InputCapabilities": "можливості",
  "OfferedModels.InputCapabilitiesUnknown": "не визначено",
  "OfferedModels.InputCapability.text": "текст",
  "OfferedModels.InputCapability.image": "зображення",
  "OfferedModels.InputCapability.document": "документ",
  "OfferedModels.InputCapability.audio": "аудіо",
  "OfferedModels.InputCapability.video": "відео",
  "OfferedModels.ExecutionRegion.EuGuaranteedShort": "обробка в ЄС",
  "OfferedModels.ExecutionRegion.NoRegionalGuaranteeShort": "без гарантії ЄС",
  "OfferedModels.InfrastructureOperator.MqorvaShort": "mQorva",
  "OfferedModels.InfrastructureOperator.ExternalShort": "зовнішня",
  "Enabled": "активовано",
  "Pricing": "Ціни",
  "Input price per million": "Вхідна ціна за мільйон",
  "Output price per million": "Ціна випуску за мільйон",
  "Unit price": "Ціна за одиницю",
  "Price per image": "Ціна за зображення",
  "Image unit": "Зображення",
  "Input": "Введення",
  "Output": "Вихід",
  "Cached input": "кешоване введення",
  "Cache write": "запис у кеш",
  "Official provider price": "офіційна ціна провайдера",
  "Internal cost basis": "внутрішня база витрат",
  "Price current": "актуально",
  "Price stale": "застаріло",
  "Price update required": "Ціна для цієї моделі відсутня",
  "Internal cost basis required": "потрібна внутрішня база витрат",
  "Price billing model unsupported": "вартість не розраховується",
  "Price billing model unsupported hint":
    "Ціна провайдера для цієї моделі не відповідає даним про споживання, які фіксуються для її типу операції. Тому використання обліковується без вартості, доки не буде додано розрахунок.",
  "Pricing managed automatically": "Ціни провайдера визначаються автоматично й не редагуються тут.",
  "Price source": "джерело ціни",
  "Fetched at": "отримано",
  "Long context pricing": "ціна довгого контексту від",
  "Processing": "Обробка",
  "Max parallel": "максимальний паралелізм",
  "Request delay": "Відстань запиту",
  "Request timeout": "Час очікування запиту",
  "Max retry attempts": "максимум повторень",
  "Max output tokens": "максимальна кількість токенів випуску",
  "Reasoning": "глибина міркування",
  "Reasoning off": "вимкнено",
  "Reasoning minimal": "мінімально",
  "Reasoning low": "низько",
  "Reasoning medium": "середньо",
  "Reasoning high": "високо",
  "Reasoning extra high": "дуже високо",
  "Reasoning maximum": "максимально",
  "Value must not be negative": "Значення не може бути від’ємним.",
  "Max parallel range error": "Паралелізм має бути між 1 і 64.",
  "Request delay range error": "Інтервал запиту має бути від 0 до 60000 мс.",
  "Request timeout range error": "Час очікування запиту має становити від 5 до 43200 секунд.",
  "Max retry attempts range error": "Кількість повторів має бути від 0 до 10.",
  "Max output tokens range error": "Вихідні маркери мають бути від 1 до 200 000.",
  "Save": "зберегти",
  "Cancel": "скасувати",
  "Required": "Обов'язкове поле",
  "No models configured": "Немає налаштованих моделей",
  "Actions": "Дії",
  "OfferedModels.Saved": "Моделі збережено",
  "OfferedModels.DeleteTitle": "Видалити модель?",
  "OfferedModels.Delete": "видалити",
  "OfferedModelInUse": "Модель усе ще використовується принаймні одним агентом, тому її не можна вимкнути або видалити.",
  "Current": "поточна",
  "Use custom model": "Використати \"{model}\" як власну модель",
  "OpenRouter data collection": "Заборонити постачальникам використовувати дані",
  "OpenRouter data collection help": "Допускаються лише постачальники, які не використовують вхідні та вихідні дані для аналізу, навчання чи іншого постійного використання.",
  "OpenRouter zero data retention": "Заборонити зберігання даних у постачальника (ZDR)",
  "OpenRouter processing region": "Регіон обробки",
  "OpenRouter region global": "Увесь світ",
  "OpenRouter region europe": "Європа (ЄС/ЄЕЗ, Велика Британія, Швейцарія)",
  "OpenRouter region us": "США",
  "OpenRouter check and save": "Перевірити та зберегти",
  "OpenRouter profile price unavailable": "Ціну для цієї конфігурації не визначено",
  "OpenRouter profile price help": "Діапазон каталожних цін регіональних маршрутів із цими вимогами. Політики облікового запису можуть звузити вибір. Оплачується фактично використаний маршрут.",
  "OpenRouter save test help": "Текстові профілі та профілі рішень перевіряються невеликим платним запитом. Для медіа перевіряються модель і маршрут без генерації. Регіон Європи не гарантує обробку лише в ЄС.",
  "OpenRouter zero data retention help": "Допускаються лише постачальники з Zero Data Retention. Вхідні та вихідні дані не зберігаються після запиту.",
  "OpenRouter privacy heading": "Допустима обробка даних в OpenRouter",
  "OpenRouter EU processing only": "Дозволити обробку лише в ЄС",
  "OpenRouter EU processing only help": "OpenRouter використовує лише кінцеву точку ЄС. Модель має бути доступна там; переходу на глобальний маршрут немає.",
} as const;

export const sharedOfferedModelsIt = {
  "OfferedModels.ExecutionRegion.EuropeGuaranteed": "Europa (UE/SEE, Regno Unito, Svizzera)",
  "OfferedModels.ExecutionRegion.UsGuaranteed": "Elaborazione esclusivamente negli USA",
  "OpenRouterProfile.Authentication": "La chiave OpenRouter manca o è stata rifiutata.",
  "OpenRouterProfile.Credits": "Il saldo OpenRouter non è sufficiente per il test.",
  "OpenRouterProfile.ProviderRegionRequired": "Il vincolo regionale non è compatibile con l’accesso del fornitore selezionato.",
  "OpenRouterProfile.Permission": "I permessi o le politiche dell'account impediscono questa elaborazione.",
  "OpenRouterProfile.NoRoute": "Nessuna rotta OpenRouter corrisponde a modello, regione e requisiti di riservatezza.",
  "OpenRouterProfile.RateLimited": "OpenRouter sta limitando le richieste. Riprovare più tardi.",
  "OpenRouterProfile.Timeout": "Il test di disponibilità OpenRouter è scaduto.",
  "OpenRouterProfile.InvalidResponse": "Il test OpenRouter non ha restituito una risposta completa e valida.",
  "OpenRouterProfile.Unavailable": "OpenRouter non ha potuto eseguire questa configurazione.",
  "OfferedModels.OperationType": "Tipo di operazione",
  "OfferedModels.OperationType.chat": "Chat",
  "OfferedModels.OperationType.embedding": "Embedding",
  "OfferedModels.OperationType.classification": "Classificazione",
  "OfferedModels.OperationType.decisions": "Decisioni",
  "OfferedModels.OperationType.image": "Immagine",
  "OfferedModels.OperationType.video": "Video",
  "OfferedModels.OperationType.speech": "Sintesi vocale",
  "OfferedModels.OperationType.transcription": "Trascrizione",
  "OfferedModels.OperationType.music": "Musica",
  "OfferedModels.OperationType.sound_effect": "Effetto sonoro",
  "Models": "Modelli",
  "Add Offered Model": "Aggiungi modello",
  "Edit Offered Model": "Modifica modello",
  "Profile Name": "Nome del profilo",
  "Strengths and weaknesses": "Punti di forza e di debolezza",
  "Provider": "Fornitore",
  "Model": "modello",
  "OfferedModels.Provider": "fornitore",
  "OfferedModels.Model": "modello",
  "OfferedModels.ModelLocation": "Esecuzione",
  "OfferedModels.ProcessingLocations": "Sedi di elaborazione",
  "OfferedModels.ProcessingLocation": "Sede del modello",
  "OfferedModels.SelectOneProcessingLocation": "Seleziona esattamente una sede del modello.",
  "OfferedModels.LocationAndPrivacy": "Sede e privacy",
  "OfferedModels.OnlyEurope": "elabora solo in Europa (UE/SEE, Regno Unito, Svizzera)",
  "OfferedModels.OnlyUs": "elabora solo negli USA",
  "OfferedModels.ExecutionParameters": "Parametri di esecuzione",
  "OfferedModels.ModelLocation.MqorvaInfrastructure": "infrastruttura mQorva",
  "OfferedModels.ModelLocation.MqorvaInfrastructureDescription": "Possono essere utilizzati modelli ospitati nell'infrastruttura gestita da mQorva.",
  "OfferedModels.ModelLocation.EuProviders": "UE",
  "OfferedModels.ModelLocation.EuProvidersDescription": "Possono essere utilizzati modelli ospitati nell'UE.",
  "OfferedModels.ModelLocation.WorldProviders": "resto del mondo",
  "OfferedModels.ModelLocation.WorldProvidersDescription": "Possono essere utilizzati modelli ospitati al di fuori dell'UE, inclusi fornitori senza una regione garantita.",
  "OfferedModels.ExecutionRegion.EuGuaranteed": "elaborazione esclusivamente nell'UE",
  "OfferedModels.ExecutionRegion.NoRegionalGuarantee": "nessuna regione di elaborazione garantita",
  "OfferedModels.InfrastructureOperator.Mqorva": "infrastruttura gestita da mQorva",
  "OfferedModels.InfrastructureOperator.External": "infrastruttura esterna",
  "OfferedModels.ExecutionPlacementUnavailable": "sede di esecuzione non disponibile",
  "OfferedModels.InputCapabilities": "capacità",
  "OfferedModels.InputCapabilitiesUnknown": "non determinate",
  "OfferedModels.InputCapability.text": "testo",
  "OfferedModels.InputCapability.image": "immagine",
  "OfferedModels.InputCapability.document": "documento",
  "OfferedModels.InputCapability.audio": "audio",
  "OfferedModels.InputCapability.video": "video",
  "OfferedModels.ExecutionRegion.EuGuaranteedShort": "elaborazione UE",
  "OfferedModels.ExecutionRegion.NoRegionalGuaranteeShort": "nessuna garanzia UE",
  "OfferedModels.InfrastructureOperator.MqorvaShort": "mQorva",
  "OfferedModels.InfrastructureOperator.ExternalShort": "esterna",
  "Enabled": "attivato",
  "Pricing": "Prezzi",
  "Input price per million": "Prezzo d'ingresso per milione",
  "Output price per million": "Prezzo di emissione per milione",
  "Unit price": "Prezzo unitario",
  "Price per image": "Prezzo per immagine",
  "Image unit": "Immagine",
  "Input": "Ingresso",
  "Output": "Uscita",
  "Cached input": "Input memorizzato nella cache",
  "Cache write": "Scrittura nella cache",
  "Official provider price": "Prezzo ufficiale del provider",
  "Internal cost basis": "Base di costo interna",
  "Price current": "attuale",
  "Price stale": "obsoleto",
  "Price update required": "Manca il prezzo per questo modello",
  "Internal cost basis required": "Base di costo interna richiesta",
  "Price billing model unsupported": "costo non calcolabile",
  "Price billing model unsupported hint":
    "Il prezzo del fornitore per questo modello non corrisponde ai dati di consumo rilevati per il suo tipo di operazione. L'utilizzo viene quindi registrato senza costi finché il calcolo non viene aggiunto.",
  "Pricing managed automatically": "I prezzi del provider vengono determinati automaticamente e non possono essere modificati qui.",
  "Price source": "Fonte del prezzo",
  "Fetched at": "recuperato il",
  "Long context pricing": "Prezzo contesto lungo da",
  "Processing": "Elaborazione",
  "Max parallel": "massimo parallelismo",
  "Request delay": "Richiedi distanza",
  "Request timeout": "Richiedi timeout",
  "Max retry attempts": "massime ripetizioni",
  "Max output tokens": "gettoni di emissione massima",
  "Reasoning": "ragionamento",
  "Reasoning off": "disattivato",
  "Reasoning minimal": "minimo",
  "Reasoning low": "basso",
  "Reasoning medium": "medio",
  "Reasoning high": "alto",
  "Reasoning extra high": "molto alto",
  "Reasoning maximum": "massimo",
  "Value must not be negative": "Il valore non può essere negativo.",
  "Max parallel range error": "Il parallelismo deve essere compreso tra 1 e 64.",
  "Request delay range error": "L'intervallo di richiesta deve essere compreso tra 0 e 60000 ms.",
  "Request timeout range error": "Il timeout della richiesta deve essere compreso tra 5 e 43200 secondi.",
  "Max retry attempts range error": "Le ripetizioni devono essere comprese tra 0 e 10.",
  "Max output tokens range error": "I token di output devono essere compresi tra 1 e 200000.",
  "Save": "salvare",
  "Cancel": "annullare",
  "Required": "Campo obbligatorio",
  "No models configured": "Nessun modello configurato",
  "Actions": "Azioni",
  "OfferedModels.Saved": "Modelli salvati",
  "OfferedModels.DeleteTitle": "Eliminare il modello?",
  "OfferedModels.Delete": "eliminare",
  "OfferedModelInUse": "Il modello è ancora utilizzato da almeno un agente e non può essere disattivato o eliminato.",
  "Current": "attuale",
  "Use custom model": "Usa \"{model}\" come modello personalizzato",
  "OpenRouter data collection": "Vieta ai fornitori di usare i dati",
  "OpenRouter data collection help": "Sono ammessi solo fornitori che non usano input e output per analisi, addestramento o altri usi non transitori.",
  "OpenRouter zero data retention": "Vieta la conservazione dei dati presso il fornitore (ZDR)",
  "OpenRouter processing region": "Regione di elaborazione",
  "OpenRouter region global": "Tutto il mondo",
  "OpenRouter region europe": "Europa (UE/SEE, Regno Unito, Svizzera)",
  "OpenRouter region us": "USA",
  "OpenRouter check and save": "Verifica e salva",
  "OpenRouter profile price unavailable": "Prezzo per questa configurazione non determinato",
  "OpenRouter profile price help": "Intervallo dei prezzi di catalogo per le rotte regionali conformi a questi requisiti. Le politiche dell'account possono restringere la scelta. Si paga la rotta effettivamente usata.",
  "OpenRouter save test help": "I profili di testo e decisione vengono verificati con una piccola richiesta a pagamento. Per i media vengono verificati modello e percorso senza generazione. La regione Europa non garantisce un'elaborazione esclusivamente nell'UE.",
  "OpenRouter zero data retention help": "Sono ammessi solo fornitori con Zero Data Retention. Input e output non vengono conservati dopo la richiesta.",
  "OpenRouter privacy heading": "Trattamento dati consentito in OpenRouter",
  "OpenRouter EU processing only": "Consenti solo l'elaborazione nell'UE",
  "OpenRouter EU processing only help": "OpenRouter utilizza esclusivamente l'endpoint UE. Il modello deve essere disponibile lì; non viene usato il percorso globale come ripiego.",
} as const;

export const sharedOfferedModelsTranslations = {
  de: sharedOfferedModelsDe,
  en: sharedOfferedModelsEn,
  ru: sharedOfferedModelsRu,
  uk: sharedOfferedModelsUk,
  it: sharedOfferedModelsIt,
} as const;

export type SharedOfferedModelsLang = keyof typeof sharedOfferedModelsTranslations;
export type SharedOfferedModelsKey = keyof typeof sharedOfferedModelsDe;
